import { includes } from 'lodash'

export default {
  props: {
    value: {
      type: [Boolean, Number, String, Object, Array],
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    value: 'updateOption'
  },

  data () {
    return {
      selected: false,
      hidden: false
    }
  },

  created () {
    this.registerOption()
  },

  destroyed () {
    this.unregisterOption()
  },

  methods: {
    valueUpdated (values) {
      this.selected = includes(values, this.value)
    },

    registerOption () {
      this.$parent.registerOption({ instance: this, value: this.value, visible: !this.hidden })
    },

    unregisterOption () {
      this.$parent.unregisterOption({ instance: this, value: this.value, visible: !this.hidden })
    },

    updateOption () {
      this.$parent.updateOption({ instance: this, value: this.value, visible: !this.hidden })
    },

    optionClicked () {
      if (!this.disabled) {
        this.$parent.optionClicked({ instance: this, value: this.value, visible: !this.hidden })
      }
    },

    searchUpdated (searchValue) {
      const search = searchValue.toLowerCase()
      let testValue = typeof this.value === 'number' || typeof this.value === 'boolean' ? this.value.toString() : this.value
      testValue = typeof testValue === 'string' ? testValue.toLowerCase() : testValue

      const hidden = searchValue !== '' && !includes(testValue, search)

      if (this.hidden !== hidden) {
        this.hidden = hidden
        this.updateOption()
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/pro4all-ui/ui-kit/mixins/DropdownOption.js
// module id = dk16
// module chunks = 0